export function displayableCity({ city, department }) {
    if (department && department !== city) {
        return `${city}, ${department}`;
    }
    return city;
}
